var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19335 3.69231C7.91554 3.69231 8.82081 3.20407 9.35991 2.55308C9.84815 1.96313 10.2042 1.13922 10.2042 0.315321C10.2042 0.203433 10.194 0.0915448 10.1736 0C9.37008 0.0305149 8.40378 0.539098 7.82399 1.2206C7.36627 1.73935 6.94923 2.55308 6.94923 3.38716C6.94923 3.50922 6.96957 3.63128 6.97974 3.67196C7.0306 3.68214 7.11198 3.69231 7.19335 3.69231ZM4.65044 16C5.63709 16 6.07447 15.3388 7.30524 15.3388C8.55635 15.3388 8.83099 15.9797 9.92952 15.9797C11.0077 15.9797 11.7299 14.9828 12.4114 14.0064C13.1743 12.8875 13.4896 11.7889 13.5099 11.7381C13.4387 11.7177 11.3739 10.8735 11.3739 8.5035C11.3739 6.44882 13.0014 5.5232 13.0929 5.452C12.0147 3.90591 10.3771 3.86523 9.92952 3.86523C8.7191 3.86523 7.73245 4.59758 7.11198 4.59758C6.44065 4.59758 5.55571 3.90591 4.50803 3.90591C2.51439 3.90591 0.490234 5.55372 0.490234 8.66624C0.490234 10.5989 1.24294 12.6434 2.16856 13.9657C2.96195 15.0846 3.65362 16 4.65044 16Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/Apple_logo.67ef6c5d3d896bb85bc26f90dbe02d86.svg";
export { ForwardRef as ReactComponent };